// extracted by mini-css-extract-plugin
module.exports = {"footer":"dece2e673c--footer--pzyAk","text":"dece2e673c--text--mtnK3"};